import { createSlice } from '@reduxjs/toolkit';
import { emptyFormState } from '../emptyState';
import { fetchStatus } from '../status';
import { getReportOptions } from '../../api/network';

// Then, handle actions in your reducers:
const reportOptionsSlice = createSlice({
  name: 'reportOptions',
  emptyFormState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    reportOptionsFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    reportOptionsFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    reportOptionsFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
  },
});

export const { reportOptionsFetchStart, reportOptionsFetchSuccess, reportOptionsFetchFail } = reportOptionsSlice.actions;

export const reportOptionsReducer = reportOptionsSlice.reducer;



const getDateOptions = () => {
  const startMonth = 5;
  const startYear = 2017;
  const now = new Date();
  const currentMonth = now.getUTCMonth();
  const currentYear = now.getUTCFullYear();
  const optionAmount = Math.abs(currentMonth - startMonth) + (currentYear - startYear) * 12;

  if (optionAmount <= 0) {
    return [];
  }

  const dateOptions = [];
  const options= {
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  };
  for (let i = 0; i < optionAmount + 1; i++) {
    const date = new Date();
    let month = startMonth + i;
    let year = startYear;

    while (month > 11) {
      month -= 12;
      year++;
    }
    date.setDate(32);
    date.setMonth(month);
    date.setFullYear(year);

    dateOptions.push({
      label: date.toLocaleDateString("en-US", options),
      value: `${month + 1}-${year}`,
      month: month + 1,
      year,

      report_end_date:date.toLocaleDateString("en-US", options),
      report_type: "monthly",
      uid:date.toLocaleDateString("en-US", options)
    });
  }

  // Sort dateOptions in descending order by date before returning
  dateOptions.sort((a, b) => new Date(b.label).valueOf() - new Date(a.label).valueOf());
  return dateOptions;
};


export const fetchReportOptions = (data) => (dispatch) => {
  dispatch(reportOptionsFetchStart());

  if (data.reportType === 'finance') {
    dispatch(reportOptionsFetchSuccess(getDateOptions()));
  }else{
    getReportOptions(data)
      .then((payload) => {
        dispatch(reportOptionsFetchSuccess(payload.data));
      })
      .catch((error) => {
        dispatch(reportOptionsFetchFail(error));
      });
  }
};
